module.exports = __webpack_public_path__ + "static/media/obersurfaces.bc88330c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brands/obersurfaces.svg
// module id = 193
// module chunks = 37